const TaxFeeCategory = {
  Tax: 'Tax',
  FlatFee: 'FlatFee',
  CreditCardFee: 'CreditCardFee',
  PerDayFee: 'PerDayFee'
};

export default TaxFeeCategory;
